<template>
  <div class="m-popupVoucher-item">
    <div
      v-for="item in 4"
      :key="item"
      class="circle-bg"
      :class="[`circle-bg-${item}`]"
      :style="{
        background: hex
      }"
    />
    <!-- left -->
    <div class="item-left">
      <div class="item-info">
        <div>
          <span class="unit">{{ $t('CURRENCY_UNIT') }}</span>
          <span class="amount">{{ showAmount }}</span>
          <span class="typefix">OFF</span>
        </div>
        <div class="item-minStake">
          {{ stakeDesc }}
        </div>
      </div>
    </div>

    <!-- right -->
    <div class="item-right">
      <div
        class="item-btn"
        :class="{'item-btn-dis': data.status !== 1}"
        @click="useVoucher"
      >
        {{ data.status === 1 ? 'USE' : 'DETAILS' }}
      </div>
    </div>

    <div
      v-if="isAppOnly"
      class="item-platform"
    >
      App Only
    </div>
  </div>
</template>

<script>
import { prefixLink } from '@ms/config/app'
import useVoucherMixin from './useVoucherMixin.js'
import { gotoUseVoucher } from '@ms/components/userPush/vouchers'

export default {
  name: 'VoucherItem',
  props: {
    data: {
      type: Object,
      default: () => ({}),
      required: false
    },
    // 后台配色
    hex: {
      type: String,
      default: ''
    }
  },
  setup() {
    const { isAppOnly, stakeDesc, showAmount } = useVoucherMixin()

    return {
      isAppOnly,
      stakeDesc,
      showAmount
    }
  },
  methods: {
    useVoucher() {
      if (this.data.status === 1) {
        if (this.data.platform && this.data.platform.toLowerCase() === 'android') {
          this.$emit('closeVoucher')
          this.$emit('openApp', this.data.amount)
        } else {
          if (/\/sports\/list/i.test(location.pathname)) {
            this.$emit('closeVoucher')
          } else {
            const bizType = this.data.bizType || []
            gotoUseVoucher(bizType)
          }
        }
      } else {
        location.href = prefixLink('/vouchers')
      }
    }
  }
}
</script>
<style lang="less">
@import url("~wap/common/style/variable.less");

.circle-bg {
  @diameter: 12/@rem;

  position: absolute;
  z-index: 1;
  width: @diameter;
  height: @diameter;
  border-radius: 50%;
  background: #585874;
  box-shadow: inset 0 0 10/@rem 0 rgba(0, 0, 0, 30%);

  &.circle-bg-1,
  &.circle-bg-2 {
    top: 14.5/@rem;
  }

  &.circle-bg-3,
  &.circle-bg-4 {
    bottom: 14.5/@rem;
  }

  &.circle-bg-1,
  &.circle-bg-3 {
    left: -(@diameter / 2);
  }

  &.circle-bg-2,
  &.circle-bg-4 {
    right: -(@diameter / 2);
  }
}

.m-popupVoucher-item {
  position: relative;
  display: flex;
  overflow: hidden;
  width: 240/@rem;
  height: 75/@rem;
  border-radius: 4/@rem;
  margin: 10/@rem auto;
  box-shadow: 0 0 10/@rem 0 rgba(0, 0, 0, 30%);

  .item-left {
    position: relative;
    overflow: hidden;
    flex: 1;
    background: #fff;
    color: #666;

    &::before {
      position: absolute;
      z-index: 0;
      top: 35/@rem;
      right: -50%;
      width: 300/@rem;
      height: 100/@rem;
      background: #ececec;
      content: "";
      transform: rotate(-14deg);
    }

    .item-info {
      position: relative;
      z-index: 1;
      overflow: hidden;
      width: 100%;
      box-sizing: border-box;
      padding: 9/@rem 14/@rem;
      text-align: left;
      white-space: nowrap;
    }

    .unit {
      color: #3a3a3a;
      font-family: LucidaGrande;
      font-size: 20px;
    }

    .amount {
      color: #333;
      font-size: 32/@rem;
      line-height: 38/@rem;
    }

    .typefix {
      color: #333;
      font-size: 13/@rem;
    }

    .item-minStake {
      color: #333;
      font-size: 12/@rem;
      line-height: 18/@rem;
    }

    .item-time {
      color: #999;
      font-size: 10/@rem;
      font-weight: 400;
      line-height: 13/@rem;
      text-align: left;
    }

    .expiresToday {
      color: #e51717;
    }
  }

  .item-right {
    position: relative;
    display: flex;
    width: 29.6%;
    align-items: center;
    justify-content: center;

    .item-btn {
      display: flex;
      width: 100%;
      height: 100%;
      align-items: center;
      justify-content: center;
      background: #ffca26;
      color: #000;
      font-size: 15/@rem;
      font-weight: 400;

      &:active {
        background: fade(#ffca26, 80%);
      }
    }

    .item-btn-dis {
      background: #999;

      &:active {
        background: fade(#999, 80%);
      }
    }
  }

  .item-logo {
    position: absolute;
    right: 0/@rem;
    bottom: 0/@rem;
    width: 100/@rem;
  }
}
</style>
